import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Field from 'components/AddOrEditFormPage/CustomForm/Field'
import { handleSectionValueChange } from 'actions/customForm/addOrEdit'
import { startCase, lowerCase } from 'lodash'
import { getCustomAttributes } from 'actions/contacts'
import Checkbox from 'components/AddOrEditFormPage/CustomForm/Checkbox'
import getContrastYIQ from 'utils/getContrastYIQ'
// import FieldCheckbox from 'components/AddOrEditFormPage/CustomForm/FieldCheckbox'
// import {
// 	ExpansionPanel,
// 	ExpansionPanelSummary,
// 	Typography,
// 	ExpansionPanelDetails,
// } from '@material-ui/core'
// import { ExpandMore } from '@material-ui/icons'

const PhoneOpt = connect(
  state => ({
    backgroundColor: state.signupForm.addOrEdit.values?.backgroundColor?.value,
    customerBusinessName: state.data?.account?.business_name,
  }),
  null,
)(({ backgroundColor, customerBusinessName }) => {
  return (
    <div>
      <input type="checkbox" name="phone_opt" />
      <label style={{ color: getContrastYIQ(backgroundColor) }} for="phone_opt">
        Yes, I would like to receive text messages from {customerBusinessName}.
        <br />
        <em style={{ fontSize: 10 }}>
          By selecting "Yes" above, message and data rates may apply. Message
          frequency varies. You can opt out by responding STOP at any time. For
          more information, please review our Privacy Policy and Terms Of
          Service Below.
        </em>
        <br />
      </label>
    </div>
  )
})

const EmailOpt = connect(
  state => ({
    backgroundColor: state.signupForm.addOrEdit.values?.backgroundColor?.value,
    customerBusinessName: state.data?.account?.business_name,
  }),
  null,
)(({ backgroundColor, customerBusinessName }) => {
  return (
    <div>
      <input type="checkbox" name="email_opt" />
      <label style={{ color: getContrastYIQ(backgroundColor) }} for="email_opt">
        Sign up for promotional, updates and service emails from{' '}
        {customerBusinessName}
      </label>
    </div>
  )
})

const contactfield = ({
  isEditing,
  isDragging,
  item,
  handleSectionValueChange,
  customAttributesLoadStatus,
  customAttributes,
  getCustomAttributes,
}) => {
  if (!customAttributesLoadStatus) {
    getCustomAttributes()
  }

  const defaultSections = [
    { value: 'email', label: 'Email' },
    { value: 'phone', label: 'Phone' },
    { value: 'first_name', label: 'First name' },
    { value: 'middle_name', label: 'Middle name' },
    { value: 'last_name', label: 'Last name' },
    { value: 'location', label: 'Location' },
  ]

  const customSections = customAttributesLoadStatus
    ? Object.values(customAttributes)
        .filter(customAttribute => customAttribute.name)
        .map(customAttribute => ({
          value: customAttribute.name,
          label: startCase(customAttribute.name),
        }))
    : []

  const sections = [...defaultSections, ...customSections]

  if (item?.contactfield?.field_name === 'phone_opt') {
    return <PhoneOpt />
  }

  if (item?.contactfield?.field_name === 'email_opt') {
    return <EmailOpt />
  }

  return isEditing ? (
    <div style={{ paddingTop: 10 }}>
      <Field
        handleChange={({ property, value, type, id }) => {
          handleSectionValueChange({
            property,
            value /* : { field_name: value } */,
            id,
            type: 'contactfield',
          })

          handleSectionValueChange({
            property: 'description',
            value: `Enter your ${lowerCase(value)}`,
            id,
          })

          handleSectionValueChange({
            property: 'label',
            value: startCase(value),
            id,
          })
        }}
        property="field_name"
        select
        statePath={state =>
          state.customForm.addOrEdit.sectionsByID[item.id].contactfield
            .field_name
        }
        items={sections}
        sectionID={item.id}
      />
      <Field
        label="Description"
        property="description"
        statePath={state =>
          state.customForm.addOrEdit.sectionsByID[item.id].description
        }
        placeholder="Enter a description"
        sectionID={item.id}
      />
      <Checkbox
        label="Required"
        property="required"
        statePath={state =>
          state.customForm.addOrEdit.sectionsByID[item.id].contactfield.required
        }
        type="contactfield"
        sectionID={item.id}
      />
      {/* <ExpansionPanel>
				<ExpansionPanelSummary expandIcon={<ExpandMore />}>
					<Typography style={{ fontSize: 15 }}>Advanced</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails style={{ display: 'block' }}>
					<Checkbox
						label="Hidden"
						property="hidden"
						statePath={(state) =>
							state.customForm.addOrEdit.sectionsByID[item.id].contactfield.hidden ||
							false
						}
						type="contactfield"
						sectionID={item.id}
					/>
					<Checkbox
						label="Read only"
						property="readonly"
						statePath={(state) =>
							state.customForm.addOrEdit.sectionsByID[item.id].contactfield.readonly ||
							false
						}
						type="contactfield"
						sectionID={item.id}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel> */}
    </div>
  ) : (
    <>
      {item?.label && (
        <h3
          style={{
            marginBottom: 0,
            marginTop: '18.72px',
            fontSize: '18.72px',
            padding: 2,
          }}
        >
          {item.label || null}
          {item?.contactfield?.required && (
            <span style={{ color: 'red' }}>*</span>
          )}
        </h3>
      )}
      {item?.description && (
        <div
          style={{
            marginBottom: 0,
            marginTop: '1.72px',
            fontSize: '12.72px',
            padding: 2,
          }}
        >
          {item.description}
        </div>
      )}
      <input
        className={
          item?.required
            ? 'vast_contactfield reach_required'
            : 'vast_contactfield'
        }
        type="text"
        name={item?.contactfield?.field_name}
        datatype="text"
        style={{
          width: '100%',
          maxWidth: 500,
          border: '1px solid rgba(0, 0, 0, 0.1)',
          padding: 8,
          marginBottom: 8,
          marginTop: 0,
          borderRadius: 35,
        }}
      />
    </>
  )
}

export default connect(
  state => ({
    customAttributesLoadStatus: state.loadStatus.customAttributes,
    customAttributes: state.contacts.customAttributes,
  }),
  dispatch =>
    bindActionCreators(
      { handleSectionValueChange, getCustomAttributes },
      dispatch,
    ),
)(contactfield)
